"use client";

import NotificationIcon from "@/app/_components/Icons/NotificationIcon";
import { LoadingButton } from "@mui/lab";
import { Card, Typography, useScrollTrigger } from "@mui/material";

export default function NoVariantsSection() {
  const trigger = useScrollTrigger();

  return (
    <>
      <Card
        elevation={0}
        sx={{
          boxShadow: { xs: "unset", md: "3px 6px 24px -6px #E8D9CF29, -3px 0px 24px -6px #E8D9CF1F" },
          backgroundColor: { xs: "transparent", md: "#fff" },
          borderRadius: 3,
          position: "sticky",
          transition: "0.3s all",
          top: trigger ? "88px" : "158px",
          width: "100%",
          p: { xs: 0, md: 2 },
        //   pt: { xs: 6, md: 6 },
        }}
      >
        <Typography sx={{mb:2}} variant="body2" color={"secondary"}>
          این کالا فعلا موجود نیست اما می‌توانید زنگوله را بزنید تا به محض موجود شدن، به شما خبر دهیم.
        </Typography>
        <LoadingButton
          size={"medium"}
          variant={"contained"}
          disableElevation={true}
          disabled
          fullWidth={true}
          sx={{ borderRadius: 500, height: 44, backgroundColor: "grey.800" }}
          startIcon={<NotificationIcon />}
        >
          موجود شد خبر بده
        </LoadingButton>
      </Card>
    </>
  );
}
